import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Recibo el material inmediatamente?',
  a: 'Sí. Apenas se confirme tu compra recibirás acceso inmediato para descargar todos los tomos y bonos en formato digital.'
}, {
  q: '¿Sirve para cualquier enfoque terapéutico?',
  a: 'Sí. Las preguntas pueden adaptarse a diferentes enfoques y estilos de intervención, funcionando como una herramienta de apoyo para tu práctica clínica.'
}, {
  q: '¿Necesito experiencia para aprovecharlo?',
  a: 'No. Está diseñado tanto para terapeutas que recién comienzan como para profesionales con años de experiencia.'
}, {
  q: '¿Puedo imprimir los tomos?',
  a: 'Sí. Todos los archivos están en formato PDF y puedes leerlos desde cualquier dispositivo o imprimirlos si prefieres tenerlos en tu escritorio durante las sesiones.'
}, {
  q: '¿El acceso es de por vida?',
  a: 'Sí. Compras una sola vez y el material será tuyo para siempre.'
}, {
  q: '¿Qué ocurre si no cumple mis expectativas?',
  a: 'Estás protegido por nuestra garantía de 7 días. Si consideras que el sistema no era lo que buscabas, te devolveremos el 100% de tu dinero.'
}];
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-14" data-id="element-81" data-mp="1oj9jv0vtpq43">
      <div className="mx-auto max-w-md" data-id="element-82" data-mp="1ohyh94e46oek">
        <h2 className="text-center font-display text-3xl font-bold leading-tight text-plum" data-id="element-83" data-mp="1ol49utlyc8f1">
          Preguntas Frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-84" data-mp="1xk7tbyp16pu2">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={i} className="overflow-hidden rounded-2xl border border-purple-100 bg-[#faf6fb]" data-id="element-85" data-mp="1slo3hn7bgtwf" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 p-4 text-left" data-id="element-86" data-mp="3ucre4ch7i8gz">
                  <span className="text-sm font-semibold text-plum" data-id="element-87" data-mp="23a0xgmn31g8o">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 text-magenta transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-88" data-mp="285zic097cg4c" />
                </button>
                <AnimatePresence initial={false} data-id="element-89" data-mp="2m6in8yidf62a">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-90" data-mp="2qxs8zo0stp8w">
                      <p className="px-4 pb-4 text-sm leading-relaxed text-plum/70" data-id="element-91" data-mp="2zwm2v6mqw1ir">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}